module.exports = __webpack_public_path__ + "static/media/icon-camera.7b5fc2c7.svg";